// extracted by mini-css-extract-plugin
export default {"orderPageContainer":"RootLayout_orderPageContainer__f51l-","orderPageMainContent":"RootLayout_orderPageMainContent__rpNex"};